import { Layout } from './layout';
import { Loading as LoadingContent } from './loading';

export function InventoryBelowMinimumStockLoading() {
  return (
    <Layout>
      <LoadingContent />
    </Layout>
  );
}
